import React from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarProvider } from 'src/components/ui/sidebar';
// import Sidebar from '../Sidebar/Sidebar';
// import Header from '../Header/Header';
import AppSidebar from '../Sidebar/AppSidebar';

export default function MainLayout() {
  return (
    <div className="h-screen overflow-hidden flex flex-col">
      <div className="flex flex-1 overflow-hidden min-h-0">
        <SidebarProvider>
          {/* <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} /> */}
          <AppSidebar />
          {/* Main content: scrollable */}
          <main className="flex-1 min-h-0 overflow-y-auto lg:gap-4 transition-all duration-300 bg-muted dark:bg-muted-dark">
            <Outlet />
          </main>
        </SidebarProvider>
      </div>
    </div>
  );
}
